var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", [
    _c(
      "span",
      { staticClass: "popup-target", attrs: { "data-position": _vm.position } },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "ui popup" }, [
      _c("p", { staticClass: "linebreak" }, [_vm._v(_vm._s(_vm.contents))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }